module.exports = __webpack_public_path__ + "img/1-Howdie-Splash-Page-MVP.63204b45.png";